import { render, staticRenderFns } from "./CdbCustomerPassportList.vue?vue&type=template&id=888477d4&scoped=true&"
import script from "./CdbCustomerPassportList.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerPassportList.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerPassportList.vue?vue&type=style&index=0&id=888477d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888477d4",
  null
  
)

export default component.exports